export const events = {
  visitModulesPage: 'Visit modules page',
  visitModuleDetailPage: 'Visit module detail page',
  goToModulesPage: 'Go to modules page',
  viewModulesPageAccess: 'View modules page access',
  goToModuleDetailPage: 'Go to module detail page',
  enableModule: 'Enable a module',
  disableModule: 'Disable a module',
  requestModuleInfo: 'Request module information',
  requestPopularModule: 'Request popular module',
  createModuleTrial: 'Create module trial for upsell',
  openUpsellTrialModal: 'Open upsell trial modal',
  viewDiscoverModal: 'Viewed discover factorial modal',
  clickRemindMeLater: 'Click on Remind me later',
  openNavatticDemoModal: 'Opens Navattic demo',
  openCheckoutModal: 'Open checkout modal',
  downloadsPitchDeck: 'Downloads pitch deck',
  openSetupGuide: 'Open setup guide',
  opensCompareFeaturesModal: 'Opens compare features modal',
  interactsWithVideo: 'Interacts with video',
  viewSelfUpsellButton: 'View self upsell button',
  viewBookAMeetingButton: 'View book a meeting button',
  viewRequestAMeetingButton: 'View request a meeting button',
  visitModulesPromotionPage: 'Visit modules promotion page',
  openUpgradeModal: 'Open upgrade modal',
}
